<template>
  <div class="language-switcher">
    <div
      class="flag-container"
      :class="{ active: currentLocale === 'en' }"
      @click="setLanguage('en')"
    >
      <svg viewBox="0 0 1235 650" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <polygon
            id="star"
            points="-0.58778527,0.809017 -0.36327126,0.118034 -0.9510565,-0.30901702 -0.22451397,-0.309017 0,-1 0.224514,-0.30901699 0.95105649,-0.30901697 0.36327126,0.118034 0.58778523,0.809017 0,0.381966"
            transform="scale(29.7314548157806)"
            fill="#FFF"
          />
          <rect id="stripe" width="1235" height="50" fill="#B22234" />
        </defs>
        <rect width="1235" height="650" fill="#FFF" />
        <use xlink:href="#stripe" />
        <use xlink:href="#stripe" y="100" />
        <use xlink:href="#stripe" y="200" />
        <use xlink:href="#stripe" y="300" />
        <use xlink:href="#stripe" y="400" />
        <use xlink:href="#stripe" y="500" />
        <use xlink:href="#stripe" y="600" />
        <rect width="494" height="350" fill="#3C3B6E" />
        <use xlink:href="#star" x="54.889" y="58.333" />
        <use xlink:href="#star" x="164.667" y="58.333" />
        <use xlink:href="#star" x="274.444" y="58.333" />
        <use xlink:href="#star" x="384.222" y="58.333" />
        <use xlink:href="#star" x="54.889" y="175" />
        <use xlink:href="#star" x="164.667" y="175" />
        <use xlink:href="#star" x="274.444" y="175" />
        <use xlink:href="#star" x="384.222" y="175" />
        <use xlink:href="#star" x="54.889" y="291.667" />
        <use xlink:href="#star" x="164.667" y="291.667" />
        <use xlink:href="#star" x="274.444" y="291.667" />
        <use xlink:href="#star" x="384.222" y="291.667" />
        <use xlink:href="#star" x="109.778" y="116.667" />
        <use xlink:href="#star" x="219.556" y="116.667" />
        <use xlink:href="#star" x="329.333" y="116.667" />
        <use xlink:href="#star" x="439.111" y="116.667" />
        <use xlink:href="#star" x="109.778" y="233.333" />
        <use xlink:href="#star" x="219.556" y="233.333" />
        <use xlink:href="#star" x="329.333" y="233.333" />
        <use xlink:href="#star" x="439.111" y="233.333" />
      </svg>
    </div>

    <div
      class="flag-container"
      :class="{ active: currentLocale === 'cz' }"
      @click="setLanguage('cz')"
    >
      <svg viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="600" fill="#d7141a" />
        <rect width="900" height="300" fill="#fff" />
        <path d="M 450,300 0,0 V 600 z" fill="#11457e" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const languages = {
  cz: "Čeština",
  en: "English",
};

// Определяем текущий язык
const currentLocale = computed(() => (languages[locale.value] ? locale.value : "en"));

// Функция смены языка
const setLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem("locale", lang);
};

// Загружаем сохранённый язык при загрузке страницы
onMounted(() => {
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale && languages[savedLocale]) {
    locale.value = savedLocale;
  }
});
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 6px;
  border-radius: 6px;
  /* background: #f5f5f5; */
  transition: 0.3s;
}

.flag-container {
  width: 24px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.3s, transform 0.3s;
}

.flag-container.active {
  opacity: 1;
  border: 2px solid #007bff;
  border-radius: 4px;
  transform: scale(1.1);
}
</style>
